import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/DEPOSITS';

export const {
    action: create,
    success: createSuccess,
    failed: createFailed,
} = createAction(
    `${domain}/CREATE`,
    (institutionId, childId, billPayerId, deposit) => ({institutionId, childId, billPayerId, deposit}),
    deposit => ({deposit}),
);

export const {
    action: deleteDeposit,
    success: deleteDepositSuccess,
    failed: deleteDepositFailed,
} = createAction(
    `${domain}/DELETE_DEPOSIT`,
    (institutionId, childId, deposit) => ({institutionId, childId, deposit}),
    depositId => ({depositId}),
);

export const {
    action: returnDeposit,
    success: returnDepositSuccess,
    failed: returnDepositFailed,
} = createAction(
    `${domain}/RETURN_DEPOSIT`,
    (institutionId, childId, deposit) => ({institutionId, childId, deposit}),
    deposit => ({deposit}),
);

export const {
    action: deleteDepositReturn,
    success: deleteDepositReturnSuccess,
    failed: deleteDepositReturnFailed,
} = createAction(
    `${domain}/DELETE_DEPOSIT_RETURN`,
    (institutionId, childId, deposit) => ({institutionId, childId, deposit}),
    deposit => ({deposit}),
);
